import MasterPage, { nameColumn, UsageCount } from "./MasterPage";
import { Manufacturer } from "../../types";
import { formatDate } from "../../utils/format";

export default function ManufacturersPage() {
    return (
        <MasterPage<Manufacturer>
            title="Manufacturers"
            subtitle="Brands of hardware products (Samsung, Apple, Sunmi…)."
            endpoint="/manufacturer"
            singular="manufacturer"
            emptyForm={{ name: "" }}
            toForm={(r) => ({ name: r.name })}
            usage={(r) => r._count?.products ?? 0}
            fields={[{ name: "name", label: "Name", kind: "text", required: true, placeholder: "e.g. Samsung" }]}
            columns={[
                nameColumn<Manufacturer>(),
                { key: "products", header: "Products", render: (r) => <UsageCount count={r._count?.products} /> },
                { key: "created", header: "Created", hideOnMobile: true, render: (r) => <span className="text-slate-500">{formatDate(r.createdAt)}</span> },
            ]}
        />
    );
}